import {bindable, bindingMode, customElement, containerless} from "aurelia-framework";
import * as _ from "lodash";

@containerless()
@customElement("popup-menu-item")
export class PopupMenuItem {

  @bindable({
    defaultBindingMode: bindingMode.oneTime
  }) click = _.noop;

  @bindable({
    defaultBindingMode: bindingMode.oneTime
  }) label;

  @bindable({
  defaultBindingMode: bindingMode.twoWay
  }) visible;

  @bindable({
  defaultBindingMode: bindingMode.twoWay
  }) icon;
}
